export default {
  title: 'Fonctionnement des frais de traitement',
  how_it_works:
    'Stripe facture ses frais à votre plateforme pour chaque paiement en ligne encaissé par vos restaurants. Les frais de traitement que vous définissez correspondent à ce que le restaurant paie pour ce paiement. S’ils sont supérieurs aux frais de Stripe, vous conservez la différence comme marge. S’ils sont inférieurs, ou si vous n’en définissez aucun, vous payez vous-même la différence.',
  stripe_rates_link: 'Voir les tarifs standard de Stripe',
  example: {
    intro:
      'Exemple : une commande de {{total}} payée par carte. Stripe facture {{stripe_fee}} ({{stripe_rate}}) à votre plateforme.',
    above: 'Votre taux {{rate}} : le restaurant paie {{fee}}, vous conservez {{difference}}.',
    below: 'Votre taux {{rate}} : le restaurant paie {{fee}}, vous payez la différence de {{difference}}.',
    none: 'Aucun taux (marge de 0 %) : le restaurant ne paie rien, vous payez la totalité des {{stripe_fee}}.',
    disclaimer:
      'Les frais de Stripe indiqués ici correspondent à son tarif standard pour les cartes dans l’EEE, à titre d’illustration. Vos frais réels dépendent de la carte, de son pays et de votre tarification Stripe.',
  },
};
